<template>
  <!-- @vue-skip TODO: 既存の型エラーを解消したら外す -->
  <div class="applicant-grid">
    <applicant-grid-item
      v-for="(applicant, index) in applicants"
      :key="index"
      :applicant="applicant"
      :snsType="snsType"
      :campaignType="campaignType"
      :isDmSending="isDmSending"
      @change_flag="changeFlag"
      @open_message_history="openMessageHistory"
      @change_ng="changeNg"
    ></applicant-grid-item>
    <div layout layout-align="space-between-center">
      <pagination
        flex="1"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        @paging="onPaging"
      ></pagination>
    </div>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia'
import { defineComponent } from 'vue'

import ApplicantGridItem from '@/client/components/_atoms/applicant_grid_item'
import ApplicantName from '@/client/components/_atoms/applicant_name'
import Icon from '@/client/components/_atoms/basic_icon'
import Pagination from '@/client/components/_atoms/pagination'
import { useTwitterApplicantStore } from '@/client/store/useTwitterApplicantStore'

export default defineComponent({
  props: {
    applicants: Array,
    snsType: {
      type: String,
      default: 'twitter'
    },
    isDmSending: {
      type: Boolean,
      default: false
    },
    campaignType: String,
    options: Object
  },
  components: {
    Pagination,
    ApplicantName,
    Icon,
    ApplicantGridItem
  },
  methods: {
    ...mapActions(useTwitterApplicantStore, ['fetchApplicants']),

    /**
     * フラグ変更処理
     * @param {{type: string, value: any}} payload
     */
    changeFlag(payload: { type: string; value: any }) {
      this.$emit('change_flag', payload)
    },

    /**
     * メッセージ配信履歴を開く
     * @param {{applicantId: number}} applicantId
     */
    openMessageHistory(payload: { applicantId: number }) {
      this.$emit('open_message_history', payload)
    },

    onPaging(payload: { pagingNo: number; limitCount?: number }) {
      this.$emit('paging', payload)

      this.fetchApplicants()
    },

    /**
     * NGアカウント追加/解除
     */
    changeNg(payload: { screenName: string; isNg: boolean; ngApplicantId: number | null }) {
      this.$emit('change_ng', payload)
    }
  }
})
</script>
